import {Component, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import {State} from "../../../core/reducers";
import {Observable} from "rxjs";
import {getCurrentGame} from "../../../games-management/store/game.selector";
import {GamePageActions} from "../../../games-management/store/game.actions";
import {canWriteCurrentGame} from "../../../game-authors/store/game-author.selectors";
import {Game} from "../../../games-management/store/game.state";

@Component({
    selector: 'app-media-library-all-files',
    template: `
        <div class="box">
            <app-game-detail-navbar class="row header">

            </app-game-detail-navbar>
            <div class=" whitebackground" style=" flex: 0 1 71px;" *ngIf="(iCanWrite|async)">
                <app-media-lib-tab-bar [gameId]="(game$|async)?.gameId"></app-media-lib-tab-bar>
            </div>
            <div style=" flex: 1 1 auto;" class="whitebackground">
                <div class="maxwidth">
                    <app-media-lib-container
                            [upload]="true"
                            [multiSelect]="true"
                            [gameId]="(game$|async)?.gameId"
                    ></app-media-lib-container>
                </div>

            </div>
            <div class="select-footer" *ngIf="(iCanWrite|async)">
                <app-library-footer></app-library-footer>

            </div>
        </div>

    `,
    styles: [`
        .whitebackground {
            background: #FFFFFF;
        }

        .select-footer {
            flex: 0 1 71px;
            background: #FFFFFF 0% 0% no-repeat padding-box;
            box-shadow: 0px -6px 15px #0000000F;
            opacity: 1;
            height: 71px;
        }


    `]
})
export class MediaLibraryAllFilesComponent implements OnInit {
    public game$: Observable<Game> = this.store.select(getCurrentGame);
    public iCanWrite: Observable<boolean> = this.store.select(canWriteCurrentGame);

    constructor(
        public store: Store<State>
    ) {
    }

    ngOnInit() {
      this.store.dispatch(GamePageActions.getGame({}));
        // this.store.dispatch(new GetCurrentGameFromRouterRequestAction());
    }

}
